import Button from '@components/Button';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';

import useOrderPrepaidCard from './hooks/useOrderPrepaidCard';
import { agreedAtom } from '../../atoms/purchasePrepaidCardAtoms';

interface Props {
    prepaidCardImageId: string;
}

function PurchaseButton({ prepaidCardImageId }: Props) {
    const { t } = useTranslation('prepaidCard');
    const agreed = useAtomValue(agreedAtom);
    const { handlePurchase, orderDisabled } = useOrderPrepaidCard(prepaidCardImageId);

    return (
        <Button fullWidth
            onClick={handlePurchase}
            disabled={orderDisabled || !agreed}>
            {t('image.payment')}
        </Button>
    );
}

export default PurchaseButton;
